module.exports = __webpack_public_path__ + "img/drone-streefkerk-snow.7efed285.jpg";